var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialog
    ? _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v("\n        Merge Existing Data Source\n      "),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pb-0" },
                [
                  _c("p", [
                    _vm._v(
                      "\n        Merge a data source into this location. The selected data source's aliases and their data will be moved to\n        this location.\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [_vm._v("Note:")]),
                    _vm._v(
                      " Data sources with non-primary aliases cannot be merged. Please separate the\n        non-primary aliases and merge them individually.\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "\n        Merge existing data sources as\n        "
                    ),
                    _c("strong", [_vm._v("Alias Type:")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "mt-1 pb-0",
                      attrs: { "hide-details": "" },
                      model: {
                        value: _vm.mergeType,
                        callback: function ($$v) {
                          _vm.mergeType = $$v
                        },
                        expression: "mergeType",
                      },
                    },
                    _vm._l(_vm.ALIAS_TYPES, function (type, index) {
                      return _c("v-radio", {
                        key: `mergeType-${index}`,
                        attrs: {
                          color: "primary",
                          label: type.text,
                          value: type.value,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("MergeAliasForm", {
                ref: "form",
                attrs: {
                  givenStation: _vm.currentDiscreteStation,
                  isQaQc: _vm.isQaQc,
                  isDepthHeightDatum: _vm.isDepthHeightDatum,
                  valid: _vm.formIsValid,
                },
                on: {
                  close: function ($event) {
                    return _vm.close()
                  },
                  "update:valid": function ($event) {
                    _vm.formIsValid = $event
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.loading,
                        disabled: !_vm.formIsValid,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        outline: "",
                        color: "secondary",
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }